import { useNavigate } from "react-router-dom";
import { NewMessageDialog } from "../../../../pages-via-dialog/new-message/new-message.dialog";
import { useState } from "react";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SendIcon from "@mui/icons-material/Send";
import { Logger } from "../../../../../../lib/logger/Logger";
import { MenuItemButton } from "../../../../../../components/src/menu-item-button/menu-item-button.component";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { useCentralStore } from "@/dentlab/src/store/Central";
import InventoryIcon from "@mui/icons-material/Inventory";

export const ClientMenu = () => {
	const navigate = useNavigate();
	const { connectRelationshipId, client } = useCentralStore((state) => ({
		connectRelationshipId: state.connectRelationshipId,
		client: state.client,
	}));

	const baseUrl = `/client/${client?.id}`;

	const createJob = useJobStore((state) => state.createJob);

	const handleCreateJob = async () => {
		const job = await createJob();
		// TODO:(Eyob, waiting for Zustand central store) Get tax rate from organization mwst_percentage
		Logger.log("handleCreateJob", { job });
		if (job) {
			navigate(`/client/${client?.id}/job/${job.id}`);
		}
	};

	const [newMessageDialogOpen, setNewMessageDialogOpen] = useState(false);

	const handleNewMessageDialogOpen = () => {
		setNewMessageDialogOpen(true);
	};

	const handleNewMessageDialogClose = () => {
		setNewMessageDialogOpen(false);
	};

	return (
		<>
			<NewMessageDialog
				open={newMessageDialogOpen}
				onClose={handleNewMessageDialogClose}
			/>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					paddingTop: "6px",
					paddingBottom: "6px",
					gap: 0,
				}}
			>
				<MenuItemButton
					title="Neuer Auftrag"
					iconLeft={<AddCircleIcon fontSize="small" />}
					onClick={handleCreateJob}
					tooltipTitle="Einen neuen Auftrag anlegen, z.B. für eine Krone oder Brücke."
				/>
				<MenuItemButton
					title="Neue Nachricht"
					iconLeft={<SendIcon fontSize="small" />}
					onClick={handleNewMessageDialogOpen}
					disabled={!connectRelationshipId}
					tooltipTitle={
						!connectRelationshipId
							? "Mindestens ein Behandler muss mit dentCONNECT verbunden sein, um Nachrichten zu senden."
							: undefined
					}
				/>
				<MenuItemButton
					title="dentCONNECT"
					iconLeft={<QuestionAnswerIcon fontSize="small" />}
					onClick={() => navigate(`${baseUrl}/connect`)}
				/>
				<MenuItemButton
					title="Rechnungen"
					iconLeft={<InsertDriveFileIcon fontSize="small" />}
					onClick={() =>
						navigate(`/accounting?recipient=${client?.id}`)
					}
				/>
				<MenuItemButton
					title="Archiv"
					iconLeft={<InventoryIcon fontSize="small" />}
					onClick={() => navigate(`${baseUrl}/archive`)}
				/>
			</div>
		</>
	);
};
